import { useAuth } from "../contexts/AuthContext";
import { Link } from "react-router-dom";
import { Crown, Shield, Calendar, Ticket } from "lucide-react";

export default function Dashboard() {
    const { user } = useAuth();
    return (
        <div data-testid="dashboard-page" className="grain">
            <section className="border-b border-line py-16 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-3">Your Court</div>
                    <h1 className="h-display text-5xl md:text-7xl">Welcome, {user?.name?.split(" ")[0] || "Fan"}.</h1>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-5 md:px-10 py-12 grid md:grid-cols-3 gap-4">
                <Card icon={Calendar} title="Schedule" desc="See upcoming Kings games." to="/schedule" testid="dash-schedule" />
                <Card icon={Ticket} title="Tryouts" desc="Apply for the 2026-27 roster." to="/tryouts" testid="dash-tryouts" />
                <Card icon={Crown} title="Royal Dispatch" desc="Your newsletter is on." to="/news" testid="dash-news" />
                {user?.role === "admin" && (
                    <Card icon={Shield} title="Admin Panel" desc="Manage the kingdom." to="/admin" testid="dash-admin" />
                )}
            </section>
        </div>
    );
}

function Card({ icon: Icon, title, desc, to, testid }) {
    return (
        <Link to={to} className="card-flat p-6 group block" data-testid={testid}>
            <Icon className="text-gold group-hover:text-gold-bright" size={28} />
            <div className="h-display text-2xl mt-5 group-hover:text-gold">{title}</div>
            <p className="text-ink text-sm mt-2">{desc}</p>
        </Link>
    );
}
